module.exports = __webpack_public_path__ + "static/media/home_test.600f63dc.svg";